import clsx from "clsx";

import Icon from "../../Components/Icon/Icon";
import IconButton from "../Buttons/IconButton";
//import NotSavedIcon from "../../images/icons/notSaved.png";
//import SavedIcon from "../../images/icons/saved.png";
import {ICON_NAMES} from "../generalConstants.js/generalConstants";
import ToolTip from "../ToolTip";

const SaveIndicator = ({isSaved, onClick, className, style}) => {
  const isBtn = onClick && typeof onClick === "function";

  return (
    <ToolTip
      title={isSaved ? "Saved" : !isSaved && isBtn ? "Not saved. Click to save" : "Not saved"}
      className={className}
      style={style}
    >
      <>
        {isBtn ? (
          <IconButton
            nameIcon={ICON_NAMES.SAVED}
            classNameIcon={clsx(isSaved ? "icon-success" : "icon-error")}
            widthIcon={30}
            heightIcon={28}
            ariaLabel="Save Cof"
            onClick={onClick}
            disabled={isSaved}
            name="Save"
          />
        ) : (
          <Icon
            name={ICON_NAMES.SAVED}
            className={clsx(isSaved ? "icon-success" : "icon-error")}
            width={30}
            height={28}
          />
        )}
      </>
    </ToolTip>
  );
};

export default SaveIndicator;
